module.exports = __webpack_public_path__ + "static/media/wand.e9bf58be.mp3";